import isReadOnly from 'notebook/structured-tables/columns/isReadOnly';
import {isTagValueStructuredTableColumn} from 'notebook/structured-tables/columns/TypePredicates';
import {StructuredTableColumn} from 'notebook/structured-tables/StructuredTableConstants';
import {SchemaField} from 'schemas/fields/SchemaFieldConstants';

import findMatchingSchemaFieldForColumn from '../columns/findMatchingSchemaFieldForColumn';
import isMissingFieldColumn from '../columns/isMissingFieldColumn';

export default function getWritableSchemaFieldIds(
  structuredTableColumns: Array<StructuredTableColumn>,
  schemaFields: Array<SchemaField>
): Array<string> {
  const writableSchemaFieldIds = [];

  for (const column of structuredTableColumns) {
    if (isReadOnly(column) || isMissingFieldColumn(column, [{allFields: schemaFields}])) {
      continue;
    }
    if (!isTagValueStructuredTableColumn(column)) {
      continue;
    }

    const schemaField = findMatchingSchemaFieldForColumn([{allFields: schemaFields}], column);
    if (schemaField) {
      writableSchemaFieldIds.push(schemaField.apiId);
    }
  }

  return writableSchemaFieldIds;
}
